module.exports = __webpack_public_path__ + "static/tools-4a62a72898dcbfee9013524fe4881154.svg";